/** Resolve after `ms`. Shared so the payment pages do not each keep a copy. */
export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
